import React from 'react';
import './aluBalcony.scss';
import SideMenu from '../../sideMenu/SideMenu';
import FindPrice from '../../findPrice/FindPrice';

import warmAl from '../../../images/alumConstructions/warmAl.png';
import coldAl from '../../../images/alumConstructions/coldAl.png';
import AluBalconyTitle from '../../../images/alumConstructions/AluminBalconyTitle.jpeg';
import aluminBalcony from '../../../images/alumConstructions/aluminBalcony.jpeg';
import variantToOpen1 from '../../../images/alumConstructions/variantToOpen1.jpeg';
import variantToOpen2 from '../../../images/alumConstructions/variantToOpen2.jpeg';
import variantToOpen3 from '../../../images/alumConstructions/variantToOpen3.jpeg';
import variantToOpen4 from '../../../images/alumConstructions/variantToOpen4.jpeg';
import terassa from '../../../images/alumConstructions/terassa.jpeg';

export default function AluBalcony() { 
    return( 
        <section className='aluBalcony'>

            <div className='container'>
                <div className='menu_content'>
                    <SideMenu/>

                    <div className='button_content'>
                    <h3>Алюминиевые лоджии / балконы / террасы / веранды</h3>
                    <img src={AluBalconyTitle} alt='алюминиевые лоджии'/>

                    <p>Наша компания занимается изготовлением и монтажом алюминиевых конструкций разных видов (фасады, лоджии, окна, перегородки) как из теплого алюминия так и из холодного.</p>
                    <p>Для начала необходимо разобраться в разнице <span>"холодного"</span> и <span>"теплого"</span> алюминия.</p>
                    <p>Алюминий характеризуется высокой теплопроводностью, что может быть и недостатком в определенных обстоятельствах - перегородки из алюминия промерзали бы при минусовых температурах. Однако, современные технологии позволяют избежать этих недостатков при производстве изделий из алюминия.</p>
                    <h3>Отличие теплого от холодного алюминия</h3>
                    <div className='coldWarmAl'>
                        <div className='kind'>
                            <div><img src={warmAl} alt='теплый алюминий'/></div>
                            <h3>Теплый алюминий и его преимущества</h3>
                            <p>Теплый алюминиевый профиль имеет две составляющие - металлические детали в нем чередуются с пластмассовыми вставками. Их называют термомостом или терморазрывом. Созданы они из стеклонасыщенного полиамида. Предназначение вставки – создание преграды на пути тепловой энергии, идущей из комнаты или кабинета на улицу (вне здания).</p>
                            <p>Алюминий с полиамидной вставкой закреплены по системе «паз-гребень». Она обеспечивает герметичность конструкции, плотное прилегание элементов. Такая система защищает помещение от сквозняков. С легкостью выносит ветровые нагрузки. Другое их наименование – многокамерные окна. Через стеклопакеты и каркас не проходит холод. Низкие температуры задерживаются. Изделия не промерзают. Теплоизоляция таких алюминиевых профилей схожа с аналогичными параметрами рам из дерева и ПВХ.</p>
                        </div>
                        <div className='kind'>
                            <div><img src={coldAl} alt='холодный алюминий'/></div>
                            <h3>Холодный алюминий и его преимущества</h3>
                            <p>Структура холодных рам однородна, неразрывна. Целостность конструкции делает ее максимально герметичной. Она защищает помещение от атмосферных осадков, пыли, влаги. Теплопотери при таком остеклении существенны из-за отсутствия полиамидной вставки. Однако холодный алюминиевый профиль обладает рядом преимуществ:</p>
                            <ul>
                                <li>Легкий вес, что дает возможность установить окна даже в сооружения без несущих стен и основательного фундамента;</li>
                                <li>Простота сборки, что делает холодные металлоконструкции актуальными для обустройства веранды или хозяйственных построек;</li>
                                <li>Дешевизна. Поэтому такие конструкции особенно востребованы для нежилых помещений, например, лоджии, неотапливаемых технических сооружений.</li>
                            </ul>
                        </div>
                    </div>


                    <div className='alBalcony'>
                        <img src={terassa} alt='алюминиевые лоджии'/>
                        <div>
                            <h3>Остекление террас, беседок и балконов</h3>
                            <p>Остекление балкона алюминием – это процесс установки на балконную плиту светопрозрачной конструкции. Состоит она из алюминиевого каркаса или рамы, стеклянных камер. Предназначена для ограждения, защиты помещения от холода, ветра, осадков, уличной пыли и звуков.</p>
                            <p>Алюминиевый каркас светопрозрачных конструкций отличается легким весом. Он не оказывает давление на несущие стены и плиты балкона. Поэтому подобные изделия можно использовать для обустройства домов старой застройки.</p>
                            <p>Остекление беседок и террас осуществляется абсолютно аналогичным образом. При этом можно выбрать различные варианты: от панорамного остекления до комбинации с "глухими" сегментами. </p>
                        </div>
                    </div>

                    <h3>Виды открывания створок</h3>
                    <div className='AlBalconyVariants'>
                        <div>
                            <h4>Глухая</h4>
                            <img src={variantToOpen1} alt='глухая створка'/>
                        </div>
                        <div>
                            <h4>Поворотная</h4>
                            <img src={variantToOpen2} alt='поворотная створка'/>
                        </div>
                        <div>
                            <h4>Раздвижная</h4>
                            <img src={variantToOpen3} alt='раздвижная створка'/>
                        </div>
                        <div>
                            <h4>Откидная</h4>
                            <img src={variantToOpen4} alt='откидная створка'/>
                        </div>
                    </div>
                    <FindPrice/>
                   
                    </div>
                </div>
            </div>
        </section>
    )
};